// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X8UA","content":"styles_content__32Ryc","row":"styles_row__uC5Gw","footer":"styles_footer__3QTzk","phraseLength":"styles_phraseLength__2Ynci"};